import { render, staticRenderFns } from "./ResearchOutputClaimStatus.vue?vue&type=template&id=2e026bf2&scoped=true&"
import script from "./ResearchOutputClaimStatus.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputClaimStatus.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputClaimStatus.vue?vue&type=style&index=0&id=2e026bf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e026bf2",
  null
  
)

export default component.exports